const APP_DEFAULT_LOCALE = 'de';
const AVAILABLE_LOCALES: Record<string, boolean> = {
  de: true,
  fr: true,
  it: true,
};
const STORAGE_KEY = 'defaultLanguage';

const determineFromBrowserLanguages = (): string => {
  const languages = navigator.languages ?? [navigator.language];

  for (const raw of languages) {
    if (!raw) continue;
    const lang = raw.toLowerCase().split('-')[0];
    if (AVAILABLE_LOCALES[lang]) return lang;
  }

  return APP_DEFAULT_LOCALE;
};

const defaultLanguage = {
  get: (): string => localStorage.getItem(STORAGE_KEY) ?? determineFromBrowserLanguages(),

  set: (language: string): void => {
    if (language === determineFromBrowserLanguages()) {
      localStorage.removeItem(STORAGE_KEY);
    } else {
      localStorage.setItem(STORAGE_KEY, language);
    }
  },
};

export { defaultLanguage };
